import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { type PropType } from 'vue';
import { useI18n } from 'vue-i18n';

import { ModalVariant } from '@exchange/libs/modals/src';
import InfoModal from '@exchange/libs/modals/src/lib/common/InfoModal.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'RestrictedJurisdictionModal',
  props: {
  variant: { type: String as PropType<ModalVariant>, required: true },
},
  emits: ["action-clicked", "view-transactions"],
  setup(__props, { emit: __emit }) {

const props = __props;

const { t } = useI18n({ useScope: 'global' });

const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(InfoModal, {
    name: "RestrictedJurisdictionModal",
    action: _unref(t)('modules.transactions.withdraw.restrictedJurisdictionModal.action'),
    title: _unref(t)('modules.transactions.withdraw.restrictedJurisdictionModal.title'),
    message: _unref(t)('modules.transactions.withdraw.restrictedJurisdictionModal.withdrawMessage'),
    variant: __props.variant,
    "icon-name": 'close-circle-bulk',
    "is-error": true,
    onActionClicked: _cache[0] || (_cache[0] = ($event: any) => (emit('action-clicked')))
  }, null, 8, ["action", "title", "message", "variant"]))
}
}

})